import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "grid grid-cols-12 gap-6" }

import { ref, computed, onMounted } from "vue";
import TextInput from "@/components/inputs/TextInput.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendationTab',
  props: {
    recommendationOptions: {
        type: Object,
        required: true
    },
    form: {
        type: Object,
        required: true
    },
    isView: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {

const props = __props;

const resetForm = (item: any, value: boolean) => {
    item.checked = value;
    item.remarks = '';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["relative justify-center col-span-12", __props.isView ? 'cursor-not-allowed' : ''])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["grid grid-cols-2 gap-6", __props.isView ? 'pointer-events-none' : ''])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.recommendationOptions, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "flex flex-col md:col-span-1 col-span-2 space-y-3"
            }, [
              _createVNode(CheckboxInput, {
                checked: item.checked,
                id: item.id,
                name: item.id,
                label: item.label,
                class: "peer",
                "onUpdate:modelValue": (value) => resetForm(item, value),
                readonly: __props.isView
              }, null, 8, ["checked", "id", "name", "label", "onUpdate:modelValue", "readonly"]),
              _createVNode(TextInput, {
                label: "Remarks",
                placeholder: "Input remarks",
                name: 'remarks_' + item.id,
                id: 'remarks_' + item.id,
                disabled: !item.checked || __props.isView,
                textarea: "",
                modelValue: item.remarks,
                "onUpdate:modelValue": ($event: any) => ((item.remarks) = $event)
              }, null, 8, ["name", "id", "disabled", "modelValue", "onUpdate:modelValue"])
            ]))
          }), 128))
        ], 2)
      ], 2)
    ])
  ]))
}
}

})